import vuePaypalSmartPaymentButtons from './components/checkout'

export default vuePaypalSmartPaymentButtons



// WEBPACK FOOTER //
// ./src/lib.js